import Icon from '@xo-union/tk-component-icons';
import { Body1, Caption } from '@xo-union/tk-ui-typography';
import React from 'react';
import striptags from 'striptags';

import common from './headline.scss';
import { Item, ItemProps } from './Item';
import styles from './locationItem.scss';

interface Props extends Omit<ItemProps, 'children'> {
  name?: string | null;
  header: string;
  description?: string | null;
  address?: string | null;
  phone?: string | null;
  website?: string | null;
  photoPath?: string | null;
  email?: string | null;
  onClick?: Function;
}

export const LocationItem: React.FC<Props> = ({
  header,
  name,
  description,
  address,
  phone,
  photoPath,
  website,
  email,
  onClick,
  ...rest
}) => {
  return (
    <Item onClick={onClick} {...rest}>
      <div className={common.container}>
        <Caption className={styles.title}>{header}</Caption>
        <div className={styles.container}>
          <Body1 className={styles.spacing}>{name}</Body1>
          <div className={styles.contentContainer}>
            {photoPath && <img className={`${common.img} ${styles.img}`} src={photoPath} alt={name || ''} />}
            <div>
              <div className={styles.spacing}>
                {address && (
                  <span className={styles.iconContainer}>
                    <Icon className={styles.icon} name="address" /> {address}
                  </span>
                )}
                {phone && (
                  <span className={styles.iconContainer}>
                    <Icon className={styles.icon} name="phone" />
                  </span>
                )}
                {email && (
                  <span className={styles.iconContainer}>
                    <Icon className={styles.icon} name="email" />
                  </span>
                )}
                {website && (
                  <span className={styles.iconContainer}>
                    <Icon className={styles.icon} name="url" />
                  </span>
                )}
              </div>
              <Caption className={common.paragraph}>{striptags(description || '').replace(/&nbsp;/gi, ' ')}</Caption>
            </div>
          </div>
        </div>
      </div>
    </Item>
  );
};
